export function UPDATE_NEWCOUPONSCENTERFROM (state, data) {
  state.newCouponsCenterFrom = data
}
export function UPDATE_ISCOUPONSSHOW (state, data) {
  state.isCouponsShow = data
}
